import addToCart from './addToCart';
import empty from './empty';

export default {
  ...empty,
  ...addToCart,
};
